import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import SubscriptionListResults from 'src/components/subscription/SubscriptionListResults';
import SubscriptionListToolbar from 'src/components/subscription/SubscriptionListToolbar';
import { useContext } from 'react';
import LoadingList from 'src/components/LoadingList';
import DataNotFoundList from 'src/components/DataNotFoundList';
import { SubscriptionContext } from 'src/context/SubscriptionContext';

const SubscriptionList = ({ subscriptions, type }) => {
  const {
    loading,
    deleteSubscription,
    searchSubscriptions,
    paginateSubscription,
  } = useContext(SubscriptionContext);

  const render = () => {
    if (loading) {
      return (<LoadingList />);
    }

    if (subscriptions && subscriptions.data && subscriptions.data.length > 0) {
      return (
        <SubscriptionListResults type={type} subscriptions={subscriptions} exclude={deleteSubscription} paginate={paginateSubscription} />
      );
    }
    return (<DataNotFoundList />);
  };

  return (
    <>
      <SubscriptionListToolbar search={searchSubscriptions} />
      <Box sx={{ pt: 3 }}>
        {render()}
      </Box>
    </>
  );
};

SubscriptionList.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default SubscriptionList;
